import React, { ReactNode } from 'react';

import './FlashMessage.scss';

interface Props {
    // passed condition if flash message is visible
    visible: boolean;
    children: ReactNode;
    error?: boolean;
}

export const FlashMessage: React.FunctionComponent<Props> = (props) => {
    // internal flag to hide flash message after a few seconds
    const [isVisible, setIsVisible] = React.useState(false);

    const timeOut = () => {
        // remove flash message after 5 seconds
        setTimeout(() => {
            setIsVisible(false);
        }, 5000);
    };

    React.useEffect(() => {
        if (props.visible === true) {
            setIsVisible(true);
            timeOut();
        }
    }, [props.visible]);

    return (
        <div
            className={
                'flash-message' +
                (props.visible && isVisible ? ' flash-message--visible' : '') +
                (props.error ? ' flash-message--error' : '')
            }
        >
            <p>{props.children}</p>
        </div>
    );
};
